import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';

@Component({
  name: 'PlayerCountComponent'
})
export default class PlayerCountComponent extends TombolaBaseComponent {
  @Prop() public gameNumberOfPlayers: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_components/player-count/player-count.component.ts